import { SelectOption } from '../searchableSelect/searchableSelectTypes';
import { getTransactionTypeName } from '../dashboard/addTransaction/transactionTypeSelection';
import { useLanguage } from '../../context/LanguageContext';
import { useTimer } from '../../context/TimerContext';
import { getTranslationFromTranslatableEntity } from '../../constants/matter';
import { useTransactionTypeList } from '../../hooks/useTransactionTypeList';
import { useTransactionTypeSelectFilters } from '../dashboard/addTransaction/useTransactionTypeSelectFilters';
import { ITimer } from '../../interface/timer';

/** The props `SearchableSelect` needs to pick a timer's transaction type, from the hour-based list the picker screen uses. */
export const useTimerTransactionTypeSelect = () => {
  const { timer, updateTimer } = useTimer();
  const { getAppLanguageCode } = useLanguage();
  const transactionTypeList = useTransactionTypeList({ onlyHourBased: true, isFromTimer: true });
  const {
    formatedTransactionType,
    setSearchValue,
    fetchNextPage,
    hasNextPage,
    isTransactionTypeLoading,
    isFetchingNextPage,
  } = transactionTypeList;
  const filters = useTransactionTypeSelectFilters(transactionTypeList);
  const appLanguage = getAppLanguageCode();

  const options: SelectOption[] = formatedTransactionType.map((type) => ({
    value: type.id,
    label: getTransactionTypeName(type.translations, appLanguage),
  }));
  const value: SelectOption | null = timer?.transactionType?.id
    ? {
        value: timer.transactionType.id,
        label: getTransactionTypeName(timer.transactionType.translations, appLanguage),
      }
    : null;

  const onChange = (option: SelectOption) => {
    const type = formatedTransactionType.find(({ id }) => id === option.value);
    if (!type) return;
    updateTimer({
      ...timer,
      transactionType: type,
      transactionTypeId: type.id,
      isTransactionTypeManuallyAdded: true,
      ...(!timer?.isSubjectManuallyAdded && {
        subject: getTranslationFromTranslatableEntity(type.translations, appLanguage),
      }),
    } as ITimer);
  };

  return {
    options,
    value,
    filters,
    onChange,
    onSearch: setSearchValue,
    onLoadMore: fetchNextPage,
    hasMore: Boolean(hasNextPage),
    loading: isTransactionTypeLoading,
    loadingMore: isFetchingNextPage,
  };
};
